import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from '@app/services/toast.service';
import PaginationOptions from '../../../../../models/PaginationOptions';
import { HelpersService } from '../../../../../services/helpers.service';
import { NavService } from '../../../../../services/nav.service';
import * as Global from '../../../../../global';
import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CityLodgingItemComponent } from '@app/dashboard-layout/includes/city-lodging-item/city-lodging-item.component';
import { UserService } from '../../../../../services/user.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'grade-details',
  standalone: true,
  imports: [NgIf, CurrencyPipe, MatIconModule, MatToolbarModule, NgFor,CityLodgingItemComponent, NgxSkeletonLoaderModule],
  templateUrl: './grade-details.component.html',
  styleUrl: './grade-details.component.scss',
})
export class GradeDetailsComponent {
  @Input() data: any = null;
  isLoading: boolean = false;
  Global = Global;
  userData: any = null;
  travelClass: string[] = [];
  formGroup!: FormGroup;
  constructor(
    private helpers: HelpersService,
    public toastr: ToastService,
    public navService: NavService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private userService: UserService
  ) {}
  ngOnChanges() {
    this.userData=null
    this.isLoading = true;
    this.getUserInfoDetails(this.data?.details?.id);
  }

  getUserInfoDetails(id: string) {
    this.userService.getUserInfoDetails({ id: id }).subscribe({
      next: (res: any) => {
        this.userData = res?.userInfoDetails;
        this.travelClass = this.userData?.travelClass?.split(';') ?? [];
      },
      error: (err: any) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  /** T1–T3 lodging limits for the entitlements card. */
  lodgingTiers() {
    const u = this.userData;
    return ['T1', 'T2', 'T3'].map((label) => ({
      label,
      names: u?.[`${label.toLowerCase()}CitiesName`],
      actual: u?.[`is${label}LOActuals`],
      amount: u?.[`${label.toLowerCase()}CitiesLOAmount`],
      wrActual: u?.[`is${label}LOWRActuals`],
      wrAmount: u?.[`${label.toLowerCase()}CitiesLOWRAmount`],
    }));
  }

  /** Up to two initials for the profile avatar, e.g. "Rahil Siddiqui" → "RS". */
  initials(name: string | null | undefined): string {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
    return (parts[0].charAt(0) + last).toUpperCase();
  }
}
